<template>
 <div>
<div >
    <div class="detailsTitle">
       <h4>转货操作</h4>
       <div @click="back"><i class="fa fa-reply"></i></div>
     </div>
        <el-form :inline="true" :rules="rules" :model="HTfrom" ref="HTfrom" class="demo-form-inline jiaoyan" label-width="120px" size="mini">
        <div >
               <el-form-item label="新客户名称:" prop="newCustomer">
                <!-- <el-input  placeholder="" maxlength="40" @blur="xkhmcFn()" v-model="HTfrom.newCustomerName" ></el-input> -->
                <el-select v-model="HTfrom.newCustomer"  filterable remote placeholder="请输入关键词" allow-create default-first-option
                 :remote-method="xkhmcFn" value-key="custerCode" :loading="loading1">
                  <el-option v-for="item in customerList" :key="item.custerCode" :label="item.custerName" :value="item"> </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="新客户联系人:" prop="newCustomerContacts">
                <el-input  placeholder=""  maxlength="10" v-model="HTfrom.newCustomerContacts"></el-input>
              </el-form-item>
              <el-form-item label="新客户联系电话:" prop="newCustomerPhone">
                <el-input  placeholder=""  maxlength="11" v-model="HTfrom.newCustomerPhone"></el-input>
              </el-form-item> -->
              <el-form-item label="备注:" prop="remark">
                <el-input  placeholder=""  maxlength="500" v-model="HTfrom.remark"></el-input>
              </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-form-item>
           <p class="margin0">货物重量<span class="red">{{HTfrom.allWeight}}</span>吨</p>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="delFn">删除</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addFN">加卷</el-button>
          </el-form-item>

       </div>
        </el-form>
        <el-table :data="goodList"  ref="table"   bordersize="mini"  @row-click="handleRowClick" class="table"  border>
        <el-table-column type="selection" width="55" ></el-table-column>
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column property="cargoBarcode"  width="150" label="捆包号"></el-table-column>
            <el-table-column property="productTypeName" label="货物类型"></el-table-column>
        <el-table-column property="productName" width="100" label="品名"></el-table-column>
        <el-table-column property="model" width="120" label="材质"></el-table-column>
        <el-table-column property="specification" width="120" label="规格"></el-table-column>
        <el-table-column property="weight" label="重量"></el-table-column>
        <el-table-column property="contractNumber" width="120" label="合同号"></el-table-column>
        <el-table-column property="agreementNumber" width="120" label="合约号"></el-table-column>
        <el-table-column property="cargoLocation" width="150" label="货位"></el-table-column>
        <el-table-column property="organizationName" width="120" label="所在仓库"></el-table-column>
          <el-table-column property="instockDate" width="160" label="入库时间"></el-table-column>
        </el-table>
      <div class="footerBtn">
        <el-button type="primary" @click="saveFn('HTfrom',0)">暂存</el-button>
         <el-button type="primary" @click="submitFn()">提交</el-button>
      </div>
      <!-- 确认密码 -->
     <el-dialog  title="确认密码" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan"  :visible.sync="dialogPaw" width="500px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="pwdFrom" ref="pwdFrom" class="demo-form-inline" label-width="100px" size="mini">
            <el-form-item label="密码:" prop="password">
                  <el-input  placeholder=""  type="password"  v-model="pwdFrom.password"></el-input>
                </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogPaw = false">取 消</el-button>
        <el-button type="primary" @click="pwaSaveFn('pwdFrom')">确 定</el-button>
      </span>
    </el-dialog>
     <el-dialog title="加卷" :visible.sync="addGoodsDialog" @close="closeDialog" width="1200px" top="20px"  center>
       <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="80px" size="mini">
        <!-- <el-form-item label="审批人">
          <el-input  placeholder="审批人"></el-input>
        </el-form-item> -->
        <div class="searchBox inpBox">
            <div class="gjhBox">
              <el-form-item label="捆包号:" prop="cargoBarcode">
                <el-input  placeholder=""   type="textarea" v-model="searchFrom.cargoBarcode" class="gjh"></el-input>
              </el-form-item>
            </div>
            <div class="item">

              <el-form-item label="货物类型:" prop="productTypeId">
                <el-select  v-model="searchFrom.productTypeId"   placeholder="请选择">
                  <el-option v-for="item in productTypes" :label="item.show_name" :value="item.item_no" :key="item.item_no"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="品名:" prop="productName">
                <el-input  placeholder="" v-model="searchFrom.productName"></el-input>
              </el-form-item>
              <el-form-item label="材质:" prop="model">
                <el-input  placeholder="" v-model="searchFrom.model"></el-input>
              </el-form-item>
              <el-form-item label="规格:" prop="specification">
              <el-input  placeholder="" v-model="searchFrom.specification"></el-input>
              </el-form-item>
                <el-form-item label="合同号:" prop="contractNumber">
                <el-input  placeholder="" v-model="searchFrom.contractNumber"></el-input>
              </el-form-item>
              <el-form-item label="合约号:" prop="agreementNumber">
                <el-input  placeholder="" v-model="searchFrom.agreementNumber"></el-input>
              </el-form-item>
              <el-form-item label="货位:" prop="cargoLocation">
               <el-input  placeholder="" v-model="searchFrom.cargoLocation"></el-input>
              </el-form-item>

               <el-form-item label="入库时间:" prop="instockDate">
                    <el-date-picker
                      v-model="searchFrom.instockDate"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
            </div>
        </div>

       <div class="searchBtnBox">
          <el-form-item>
           <p class="margin0">货物重量<span class="red">{{weight}}</span>吨</p>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
       </div>
      </el-form>
    </div>
        <el-table :data="addTable"  ref="addTable" v-loading="loading"   bordersize="mini"  @selection-change='addSelectGoods'
       @row-click="addHandleRowClick" class="table" height="500px" style="width: 100%" center :row-key="getRowKeys" >
        <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
        <el-table-column fixed type="index"  width="55" label="序号"></el-table-column>
       <el-table-column property="cargoBarcode" width="150" label="捆包号"></el-table-column>
        <el-table-column property="status" label="货物状态" >
          <template scope="scope">
            {{[ "正常", "锁定" ][scope.row.status]}}
          </template>
        </el-table-column>
        <el-table-column property="productTypeName" label="货物类型"></el-table-column>
        <el-table-column property="productName" width="100" label="品名"></el-table-column>
        <el-table-column property="model" width="120" label="材质"></el-table-column>
        <el-table-column property="specification" width="120" label="规格"></el-table-column>
        <el-table-column property="weight" label="重量"></el-table-column>
        <el-table-column property="contractNumber" width="120" label="合同号"></el-table-column>
        <el-table-column property="agreementNumber" width="120" label="合约号"></el-table-column>
        <el-table-column property="cargoLocation" width="120" label="货位"></el-table-column>
        <el-table-column property="organizationName" width="120" label="所在仓库"></el-table-column>
          <el-table-column property="instockDate" width="160" label="入库时间"></el-table-column>

      </el-table>
       <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addGoodsDialog = false">取 消</el-button>
        <el-button type="primary" @click="AddJsave()">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</div>
</template>

<script>
// import axios from 'axios'
import { stockTakeList, stockProductList, transferGoods, getDictionaryAll, checkPwd, getCustomerlistByTenant } from '@/api/soc-stock'
import { encryption } from '@/utils/util'
export default {
  data () {
    var id = this.$route.query.ids
    var weight = this.$route.query.weight
    var ids = []
    if (Array.isArray(id)) {
      ids = id
    } else {
      ids.push(id)
    }
    return {
      pwdFrom: {},
      dialogPaw: false,
      ids: ids,
      HTfrom: { allWeight: weight, pricingMethod: '', allPrice: 0 },
      jjfangshi: [
        { val: '', name: '请选择' },
        { val: 1, name: '按吨' },
        { val: 2, name: '包干' }
      ],
      jsfangshi: [
        { val: '', name: '请选择' },
        { val: 1, name: '电汇' },
        { val: 2, name: '现金' },
        { val: 3, name: '其他' }
      ],
      goodList: [],
      rules: {
        newCustomer: [
          { required: true, message: '请输入新客户名称', trigger: 'blur' }
        ]
      },
      addGoodsDialog: false,
      weight: 0,
      productTypes: [],
      getRowKeys (row) {
        return row.cargoId
      },
      addTable: [],
      loading: false,
      loading1: false, // 新客户名称下拉
      customerList: [],
      total: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        status: 0,
        productType: ''
      }
    }
  },
  created () {
  // 获取货物类型
    getDictionaryAll({ groupNo: 'product_type' }).then(res => {
      this.productTypes = res
      this.productTypes.unshift({ show_name: '请选择', item_no: '' })
    })
    stockTakeList({ cargoIds: this.ids.toString() }).then(res => {
      this.goodList = res
    })
  },
  mounted () {

  },

  methods: {
    // 根据查询条件获取新客户列表
    xkhmcFn (query) {
      this.loading1 = true
      getCustomerlistByTenant({
        nameLike: query,
        tenantCode: this.goodList[0].organizationId
      }).then(res => {
        this.loading1 = false
        this.customerList = res
      })
    },
    submitFn () {
      this.$refs.HTfrom.validate((valid) => {
        if (this.goodList.length >= 1) {
          if (valid) {
            this.saveFn('HTfrom', 1)
          }
        } else {
          this.$alert('请添加至少一条货物', '系统提示')
        }
      })
    },
    pwaSaveFn (formName) {
      let data = encryption({
        data: this.pwdFrom,
        key: this.global.key,
        param: ['password']
      })
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          checkPwd(data).then(res => {

          // eslint-disable-next-line handle-callback-err
          }).catch(error => {
            this.$message({
              showClose: true,
              message: '验证密码失败',
              type: 'error',
              duration: 0,
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    saveFn (formName, n) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.goodList.length >= 1) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            let arr = []
            this.goodList.forEach(item => {
              arr.push(item.cargoId)
            })
            if (typeof (this.HTfrom.newCustomer) == 'string') {
              this.HTfrom.newCustomerName = this.HTfrom.newCustomer
              this.HTfrom.newCustomerTaxId = ''
              this.HTfrom.newCustomerId = ''
            } else {
              if (this.HTfrom.newCustomer.custerCode == '') {
                this.HTfrom.newCustomer = null
              } else {
                this.HTfrom.newCustomerTaxId = this.HTfrom.newCustomer.taxpayerNumber
                this.HTfrom.newCustomerId = this.HTfrom.newCustomer.custerCode
                this.HTfrom.newCustomerName = this.HTfrom.newCustomer.custerName
              }
            }
            this.HTfrom.cargoIds = arr.toString()
            this.HTfrom.productNum = this.goodList.length
            this.HTfrom.tenantCode = this.goodList[0].organizationId
            this.HTfrom.tenantName = this.goodList[0].organizationName
            this.HTfrom.status = n
            transferGoods(this.HTfrom).then(res => {
              loading.close()
              this.$router.push({ name: 'transferGoods' })
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                duration: 0,
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            this.$alert('请添加至少一条货物', '系统提示')
          }
        }
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 删除
    delFn () {
      const selectData = this.$refs.table.selection

      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        if (this.goodList.length == 1) {
          this.$alert('不能删除全部数据', '系统提示')
        } else {
          if (selectData.length == this.goodList.length) {
            this.$alert('不能删除全部数据', '系统提示')
          } else {
            this.$confirm('是否执行删除操作?', '系统提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消'
            }).then(() => {
              selectData.forEach((val, index) => {
                // 遍历源数据
                this.goodList.forEach((v, i) => {
                  // 如果选中数据和源数据的某一条唯一标识符相等，删除对应的源数据
                  if (val.cargoId === v.cargoId) {
                    this.goodList.splice(i, 1)
                  }
                })
              })
              this.getAllWeight()
            }).catch(() => {

            })
          }
        }
      }
    },
    // 加卷
    addFN () {
      this.addGoodsDialog = true
      this.ids = []
      this.goodList.forEach(item => {
        this.ids.push(item.cargoId)
      })
      this.searchFrom.cargoIdsNotIn = this.ids
      this.searchFrom.organizationId = this.goodList[0].organizationId
      this.searchFrom.cargoIdsNotIn = this.ids
      this.getGoodsList(this.searchFrom)
      this.weight = this.HTfrom.allWeight
    },
    AddJsave () {
      const selectData = this.$refs.addTable.selection
      console.log(selectData)
      this.goodList = this.goodList.concat(selectData)
      this.addGoodsDialog = false
      this.getAllWeight()
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcode) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcode.split(/[(\r\n)\r\n]+/) }
      if (this.searchFrom.instockDate) {
        this.searchFrom.instockDateStart = this.searchFrom.instockDate[0]
        this.searchFrom.instockDateEnd = this.searchFrom.instockDate[1]
      }
      this.getGoodsList(this.searchFrom)
    },
    // 选择数据
    addSelectGoods (selection) {
      this.weight = this.HTfrom.allWeight
      var that = this

      selection.forEach(item => {
        console.log(selection)
        that.weight = (that.weight * 1000 + item.weight * 1000) / 1000
      })
    },
    // 点击选中
    addHandleRowClick (row, column, event) {
      this.$refs.addTable.toggleRowSelection(row)
    },
    // 获取货物列表
    getGoodsList (searchFrom) {
      this.loading = true
      stockProductList(searchFrom).then(res => {
        this.loading = false
        this.addTable = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getGoodsList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getGoodsList(this.searchFrom)
    },
    // 计算总重量
    getAllWeight () {
      this.HTfrom.allWeight = 0
      var that = this
      this.goodList.forEach(function (item, n) {
        that.HTfrom.allWeight = (that.HTfrom.allWeight * 1000 + item.weight * 1000) / 1000
      })
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        status: 0,
        organizationId: this.goodList[0].organizationId,
        instockDate: null
      }
    },

    back () {
      this.$router.go(-1)// 返回上一层
    },
    closeDialog () {
      this.$refs.addTable.clearSelection()
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        organizationId: this.goodList[0].organizationId,
        instockDate: null,
        status: 0
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBox{
  display: flex;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.gjhBox{
      flex-shrink: 0;
}
.gjhBox /deep/.el-textarea__inner{
  width:150px;
}
.diqu{
  display: flex;
  /deep/.el-form-item__content{
    display: flex;
    .el-input__inner{
      width: 200px!important;
    }
  }
}
/deep/ .jiage  .el-form-item__content{
  position: relative;
  .danwei{
    position: absolute;
    right: 4px;
    color: #9c9797
  }
  .el-input__inner{
        width: 120px!important;
  }
}
/deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner{
  width:180px;
}

</style>
